var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcProfilec9719A31(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 11.6211C10.1806 11.6211 8.7 10.0909 8.7 8.21052C8.7 6.33019 10.1806 4.8 12 4.8C13.8194 4.8 15.3 6.33019 15.3 8.21052C15.3 10.0909 13.8194 11.6211 12 11.6211ZM18.6 19.2H5.4V18.4421C5.4 15.5174 7.70267 13.1368 10.5333 13.1368H13.4667C16.2966 13.1368 18.6 15.5174 18.6 18.4421V19.2Z",
    fill: "#F8CF9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfilec9719A31);
export default __webpack_public_path__ + "static/media/ic-profile.c9719a31.c9719a31259e5d1880e4ffbbec75317b.svg";
export { ForwardRef as ReactComponent };